/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { JestSDK } from "./";
(window as any).JestSDK = JestSDK;
